import { render } from "./BaseTextGroup.vue?vue&type=template&id=6982a198&ts=true"
import script from "./BaseTextGroup.vue?vue&type=script&lang=ts"
export * from "./BaseTextGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__